import { ID, NewTask } from '@griply/types';
import { withRoles } from '@griply/utils';

import { newTaskConverter } from '../converters';
import { dateToFirestoreTimestamp } from '../converters/date-to-firestore-timestamp';

export const buildTaskDocument = <
  TDocRef extends { id: ID },
  TFieldValue,
  TTimestamp,
>(
  task: NewTask,
  docRef: TDocRef,
  userId: ID,
  serverTimestamp: () => TFieldValue,
  timestampFromDate: (date: Date) => TTimestamp,
  parentIds: ID[] | null,
  timeZone?: string,
): Record<string, unknown> => {
  const converted = withRoles(newTaskConverter(task, { timeZone }), userId);
  const firestoreData = dateToFirestoreTimestamp(converted, timestampFromDate);

  return {
    ...firestoreData,
    id: docRef.id,
    updatedAt: serverTimestamp(),
    parentIds,
  };
};
